import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import ArtistCard from "../components/ArtistCard";

export const ArtistsPage = () => {
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    api.get("/artists", { params: { limit: 100 } }).then(({ data }) => setArtists(data)).catch(() => {});
  }, []);

  return (
    <div className="px-6 md:px-12 py-10 max-w-7xl mx-auto" data-testid="artists-page">
      <p className="text-[10px] tracking-[0.25em] uppercase text-brand-orange font-bold mb-2">Communauté</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mb-10">
        Les artistes Voamada
      </h1>

      {artists.length === 0 ? (
        <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-10 text-center">
          <p className="text-white/70">Aucun artiste pour le moment. Créez le premier profil !</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 stagger">
          {artists.map((a) => <ArtistCard key={a.user_id} artist={a} />)}
        </div>
      )}
    </div>
  );
};

export default ArtistsPage;
